import { MealPeriod } from '../MealPeriod';

const getLabel: Record<MealPeriod, () => string> = {
    breakfast: () => 'Breakfast',
    lunch: () => 'Lunch',
    dinner: () => 'Dinner',
};

export function translateMealPeriodLabel (type: MealPeriod) {
    return getLabel[type]();
}
